/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetCountry200ResponseData } from './GetCountry200ResponseData'
import {
  GetCountry200ResponseDataFromJSON,
  GetCountry200ResponseDataFromJSONTyped,
  GetCountry200ResponseDataToJSON,
} from './GetCountry200ResponseData'

/**
 *
 * @export
 * @interface GetCountry200Response
 */
export interface GetCountry200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetCountry200Response
   */
  status: boolean
  /**
   *
   * @type {GetCountry200ResponseData}
   * @memberof GetCountry200Response
   */
  data: GetCountry200ResponseData
}

/**
 * Check if a given object implements the GetCountry200Response interface.
 */
export function instanceOfGetCountry200Response(
  value: object
): value is GetCountry200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetCountry200ResponseFromJSON(
  json: any
): GetCountry200Response {
  return GetCountry200ResponseFromJSONTyped(json, false)
}

export function GetCountry200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetCountry200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetCountry200ResponseDataFromJSON(json['data']),
  }
}

export function GetCountry200ResponseToJSON(
  value?: GetCountry200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetCountry200ResponseDataToJSON(value['data']),
  }
}
